import unblockAddedNodes from './unblockAddedNodes'


/**
 * Watches for manually-marked tags added after consent has been recorded and
 * releases the ones whose categories the visitor agreed to.
 *
 * A traditional site gets a fresh sweep on every page load, so a tag that
 * arrives after the sweep is released by the next navigation. A single-page
 * app never navigates, so without this the tag stays blocked for the rest of
 * the session and the customer's analytics and ad tags quietly stop reporting.
 */
export default function installUnblockObserver() {
  const observer = new MutationObserver(unblockAddedNodes)

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  })
}
